import { CommodityIntelegenceTowerTypes } from "./commodity-intelegence-tower.types";

const INITIAL_STATE = {
  screen: 0,
  citData: [],
  powerbiData: [],
};

const citReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CommodityIntelegenceTowerTypes.SET_SCREEN:
      return { ...state, screen: action.payload };
    case CommodityIntelegenceTowerTypes.SET_CIT_DATA:
      return { ...state, citData: action.payload };
    case CommodityIntelegenceTowerTypes.SET_POWERBI_DATA:
      return { ...state, powerbiData: action.payload };

    default:
      return state;
  }
};

export default citReducer;
